// extracted by mini-css-extract-plugin
export var cardContainer = "_nw-0";
export var cardHeader = "_nw-2";
export var collapsedState = "_nw-3";
export var dragHandle = "_nw-5";
export var dragHandleIcon = "_nw-6";
export var dragging = "_nw-1";
export var titleArea = "_nw-4";